import React, { useState, useContext } from "react";
import {
 Children,
 SidebarContainer,
 SidebarWrapper,
 SidebarLogoWrapper,
 SidebarLogo,
 SidebarBrand,
 SidebarToggler,
} from "./SidebarStyles";
import BrandLogo from "./website_logo.svg";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { SidebarItems, SidebarItemsMathMode } from "../index";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import {Toggle} from './../Toggle';
import { ThemeContext } from "./../../ThemeContext";

import emailIcon from './../../assets/icons/email.png';
import linkedin from './../../assets/icons/linkedin.png';
import github from './../../assets/icons/github.png';
import grabcad from './../../assets/icons/grabcad.png';
import spotify from './../../assets/icons/spotify.png';
import instagram from './../../assets/icons/instagram.png';
import soundcloud from './../../assets/icons/soundcloud.png';
import goodreads from './../../assets/icons/goodreads.png';
import scholar from './../../assets/icons/mortarboard.png';

const MOBILE_VIEW = window.innerWidth < 468;

const handleOpenEmail = () => {
    // Replace 'to', 'subject', and 'body' with your desired email details
    const mailtoLink = 'mailto:friesen.37@osu.edu';

    window.location.href = mailtoLink;
};

const handleOpenLinkedin = () => {
    // Replace 'to', 'subject', and 'body' with your desired email details
    const mailtoLink = 'https://www.linkedin.com/in/ori-friesen-4b10a71b6/';

    window.open(mailtoLink, '_blank')
};

const handleOpenGithub = () => {
    // Replace 'to', 'subject', and 'body' with your desired email details
    const mailtoLink = 'https://github.com/orifriesen';

    window.open(mailtoLink, '_blank')
};

const handleOpenScholar = () => {
  // Replace 'to', 'subject', and 'body' with your desired email details
  const mailtoLink = 'https://scholar.google.com/citations?user=42KQJtQAAAAJ&hl=en&oi=ao';

  window.open(mailtoLink, '_blank')
};

export default function Sidebar({ children }) {
  const [displaySidebar, setDisplaySidebar] = useState(!MOBILE_VIEW);

  // const handleSidebarDisplay = (e) => {
  //    e.preventDefault();
  //    if (window.innerWidth > 468) {
  //    setDisplaySidebar(!displaySidebar);
  //    } else {
  //    setDisplaySidebar(false);
  //    }
  //  };
  
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const isSmallScreen = useMediaQuery({ maxWidth: 670 });

  // if(isSmallScreen) {
  //   alert("Hello! I am an alert box!");
  // }

  const { 
    mathMode, 
    setMathMode,
    setTransitioning
  } = useContext(ThemeContext);

  const [checked, setChecked] = useState(mathMode);

  const handleMathModeChange = (e) => {
    const value = e.target.checked;

    // immediately move the toggle
    setChecked(value);

    setTransitioning(true);

    setTimeout(() => {
      setMathMode(value);

      setTimeout(() => {
        setTransitioning(false);
      }, 500);

    }, 500);
  };
  return mathMode 
    ? (
      <React.Fragment>
        <SidebarContainer
          displaySidebar={displaySidebar}
          isHomePage={isHomePage}
          style={{ position: "fixed", backgroundColor: "#cadce0"}}
          
        >
          <SidebarWrapper isSmallScreen={isSmallScreen}>
            <SidebarItemsMathMode displaySidebar={displaySidebar} />

            <div style={{ marginTop: "1rem" }}>
              <form>
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={handleMathModeChange}
                />
                <label htmlFor="mathmode" style={{paddingLeft: "4px"}}>Math Mode</label>
              </form>

              <hr style={{ borderTop: "1px solid black" }} />

              <ul style={{
                paddingLeft: "16px",
                margin: 0,
              }}>
                <li><a href="mailto:orifriesen@gmail.com" style={{fontFamily: "Garamond, serif", fontSize: isSmallScreen ? "10px" : "14px", textDecoration: "underline"}}>Email</a></li>
                <li><a href="https://github.com/orifriesen" target="_blank" rel="noopener noreferrer" style={{fontFamily: "Garamond, serif", fontSize: isSmallScreen ? "10px" : "14px", textDecoration: "underline"}}>GitHub</a></li>
                <li><a href="https://www.linkedin.com/in/ori-friesen-4b10a71b6/" target="_blank" rel="noopener noreferrer" style={{fontFamily: "Garamond, serif", fontSize: isSmallScreen ? "10px" : "14px", textDecoration: "underline"}}>LinkedIn</a></li>
                <li><a href="https://scholar.google.com/citations?user=42KQJtQAAAAJ&hl=en&oi=ao" target="_blank" rel="noopener noreferrer" style={{fontFamily: "Garamond, serif", fontSize: isSmallScreen ? "10px" : "14px", textDecoration: "underline"}}>Google Scholar</a></li>
              </ul>
            </div>
          </SidebarWrapper>
        </SidebarContainer>

        <Children displaySidebar={displaySidebar}>
          {children}
        </Children>
      </React.Fragment>
    )


    : (
      <React.Fragment>
      <SidebarContainer
        displaySidebar={displaySidebar}
        isHomePage={isHomePage}
        style={{ position: "fixed" }}
      >
      <SidebarWrapper isSmallScreen={isSmallScreen}>
      <SidebarLogoWrapper displaySidebar={displaySidebar}>
      {/* Logo wrapper starts */}
      <SidebarLogo>
      <span className="app-brand-logo demo">
      <img src={BrandLogo} width="100%" alt="Brand logo" />
      </span>
      </SidebarLogo>
      {/* Logo wrapper ends */}
      {/* Toggle button */}
      <SidebarToggler
      displaySidebar={displaySidebar}
      >
      </SidebarToggler>
      </SidebarLogoWrapper>
      {/* Render the SidebarItems component */}
      <SidebarItems displaySidebar={displaySidebar} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        <div style={{width: "100%", height: "100%", margin: "auto", alignContent: "end", justifyContent: "center"}}>
          <div
            style={{
              marginTop: "auto",
              display: "flex",
              justifyContent: "space-between",
              alignContent: "center",
              gap: "8px",
              paddingBottom: "0px"
            }}
          >
            <span
              style={{
                fontFamily: "mainFontPar",
                color: "#7c7788",
                paddingLeft: "8px",
                paddingTop: "1px",
                fontSize: isSmallScreen ? "6px" : "16px"
              }}
            >
              Math Mode:
            </span>

            <div
              style={{
                transform: "scale(0.8)",
                transformOrigin: "left center",
              }}
            >
              <Toggle
                checked={checked}
                onChange={handleMathModeChange}
              />
            </div>
          </div>

          <hr style={{backgroundColor: "#7c7788", border: "none", height: "1px", marginBottom: "8px", marginLeft: "4px", marginRight: "4px"}}/>

          <div style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              flexWrap: "wrap",
            }}>
            <div class="socialButton" onClick={handleOpenEmail}>
              <div class="buttonInner" style={{textAlign: "center"}}>
                  <img className='buttonImage one' src={emailIcon}/>
              </div>
            </div>
            <div class="socialButton" onClick={handleOpenLinkedin}>
              <div class="buttonInner" style={{textAlign: "center"}}>
                  <img className='buttonImage two' src={linkedin}/>
              </div>
            </div>
            <div class="socialButton" onClick={handleOpenGithub}>
              <div class="buttonInner" style={{textAlign: "center"}}>
                  <img className='buttonImage three' src={github}/>
              </div>
            </div>
            <div class="socialButton" onClick={handleOpenScholar}>
              <div class="buttonInner" style={{textAlign: "center"}}>
                  <img className='buttonImage three' src={scholar}/>
              </div>
            </div>
          </div>
          {/* <div class="socialButton" onClick={handleOpenGoodreads}>
            <div class="buttonInner" style={{textAlign: "center"}}>
                <img class="buttonImage three" src={grabcad}/>
            </div>
          </div> */}
        </div>
      </div>
      </SidebarWrapper>
      </SidebarContainer>
      {/* Render the children */}
      <Children displaySidebar={displaySidebar}>{children}</Children>
      </React.Fragment>
    );
}